import { GetterTree, ActionTree, MutationTree, ActionContext } from 'vuex';
import { Booking } from '@/models/booking.model';
import { cloneDeep } from 'lodash';

interface BookingSelected extends Booking {
  isSelected: boolean;
}

interface LoadingState {
  selectedBookings: BookingSelected[];
}

export const defaultSelectedBookingsState: LoadingState = {
  selectedBookings: []
};

const state: LoadingState = cloneDeep(defaultSelectedBookingsState);

const mutations: MutationTree<LoadingState> = {
  ADD_SELECTED_CONTACTS(returnedState: LoadingState, payload: []): void {
    returnedState.selectedBookings = payload.map(
      (elem: BookingSelected): BookingSelected => {
        return { ...elem, isSelected: true };
      }
    );
  },
  ADD_SELECTED_CONTACTS_BATCH(returnedState: LoadingState, payload: BookingSelected[]): void {
    returnedState.selectedBookings = payload;
  },
  REMOVE_SELECTED_CONTACT(returnedState: LoadingState, payload: string): void {
    returnedState.selectedBookings = returnedState.selectedBookings.filter(
      (booking: Booking): boolean => booking.id !== payload
    );
  },
  EMPTY_SELECTED_CONTACTS(returnedState: LoadingState): void {
    returnedState.selectedBookings.splice(0, returnedState.selectedBookings.length);
  }
};

const actions: ActionTree<LoadingState, {}> = {
  addSelectedContacts: ({ commit }: ActionContext<LoadingState, {}>, payload: BookingSelected): void => {
    commit('ADD_SELECTED_CONTACTS', payload);
  },
  addSelectedContactsBatch: ({ commit }: ActionContext<LoadingState, {}>, payload: BookingSelected[]): void => {
    commit('ADD_SELECTED_CONTACTS_BATCH', payload);
  },
  removeSelectedContact: ({ commit }: ActionContext<LoadingState, {}>, payload: string): void => {
    commit('REMOVE_SELECTED_CONTACT', payload);
  },
  emptySelectedContacts: ({ commit }: ActionContext<LoadingState, {}>): void => {
    commit('EMPTY_SELECTED_CONTACTS');
  }
};

const getters: GetterTree<LoadingState, {}> = {
  selectedBookings: (returnedState: LoadingState): BookingSelected[] => {
    return returnedState?.selectedBookings ?? [];
  },
  selectedBookingsIds: (returnedState: LoadingState): string[] => {
    return (returnedState?.selectedBookings ?? []).map((value: BookingSelected): string => value.id);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
